import React from 'react';
export function StickyMobileCTA() {
  return null;
}